var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var FlrToken = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, _d = _a.height, height = _d === void 0 ? 24 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M6 8.21524C6 6.9918 6.9918 6 8.21524 6H17.9069C17.9069 7.22344 16.9151 8.21524 15.6917 8.21524H6Z", fill: color }),
            React.createElement("path", { d: "M6 12.9225C6 11.6991 6.9918 10.7073 8.21524 10.7073H13.7533C13.7533 11.9307 12.7615 12.9225 11.5381 12.9225H6Z", fill: color }),
            React.createElement("path", { d: "M6 16.3838C6 15.6956 6.55789 15.1378 7.24607 15.1378C7.93426 15.1378 8.49214 15.6956 8.49214 16.3838C8.49214 17.072 7.93426 17.6299 7.24607 17.6299C6.55789 17.6299 6 17.072 6 16.3838Z", fill: color }))));
};
var templateObject_1;
